import mapboxgl from 'mapbox-gl';
import { meanBy } from 'lodash';
import { point as toPoint, midpoint, bearing } from '@turf/turf';

export default class MidwayMarker {
  constructor({ startMarker, endMarker, map }) {
    const el = document.createElement("div");
    const size = 2 * meanBy(
      [startMarker.styleOptions.paint, endMarker.styleOptions.paint],
      (m) => Math.ceil(m["circle-radius"])
    ) + 4;
    const opacity = meanBy(
      [startMarker.styleOptions.paint, endMarker.styleOptions.paint],
      (m) => m["circle-opacity"]
    );
    const startColor = startMarker.styleOptions.paint["circle-color"];
    const endColor = endMarker.styleOptions.paint["circle-color"];
    const startPoint = toPoint(startMarker.coordinates());
    const endPoint = toPoint(endMarker.coordinates());
    const midwayPoint = midpoint(startPoint, endPoint);
    const directionBearing = bearing(startPoint, endPoint);

    this.styleOptions = {
      'size': size,
      'opacity': opacity,
      'gradient-start-color': startColor,
      'gradient-end-color': endColor
    };

    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.opacity = opacity;
    el.style.borderRadius = "50%";
    el.style.border = "2px solid white";
    el.style.background = `linear-gradient(${directionBearing}deg, ${startColor}, ${startColor} 45%, white 45%, white 55%, ${endColor} 55%)`;

    this.map = map;
    this.marker = new mapboxgl
      .Marker(el, { pitchAlignment: 'map'})
      .setLngLat(midwayPoint.geometry.coordinates);
  }

  show() {
    this.marker.addTo(this.map);
  }

  hide() {
    this.marker.remove();
  }

  remove() {
    this.hide();
  }

  coordinates() {
    return this.marker.getLngLat();
  }

  pixelPoint() {
    return this.map.project(this.coordinates());
  }
}
